import React, { useEffect } from 'react';

const CloseButton = ({ onClose }) => {

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleEscKey);
        return () => window.removeEventListener('keydown', handleEscKey);
    }, [onClose]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            onClose();
        }
    };

    return (
        <div className="close-button" onClick={onClose} tabIndex="1" onKeyDown={handleKeyDown}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M2.41419 0.585793C2.02367 0.195269 1.3905 0.195269 0.999978 0.585793C0.609454 0.976318 0.609454 1.60948 0.999978 2.00001L9.79287 10.7929L0.999978 19.5858C0.609454 19.9763 0.609454 20.6095 0.999978 21C1.3905 21.3905 2.02367 21.3905 2.41419 21L11.2071 12.2071L20 21C20.3905 21.3905 21.0237 21.3905 21.4142 21C21.8047 20.6095 21.8047 19.9763 21.4142 19.5858L12.6213 10.7929L21.4142 2.00001C21.8047 1.60948 21.8047 0.976318 21.4142 0.585793C21.0237 0.195269 20.3905 0.195269 20 0.585793L11.2071 9.37869L2.41419 0.585793Z" fill="#333" />
            </svg>
        </div>
    );
  };

export default CloseButton;